import t from "./getNodeName.js";
function n(e) {
  return ["table", "td", "th"].indexOf(t(e)) >= 0;
}
export {
  n as default
};
